module.exports = __webpack_public_path__ + "img/infodemics-logo-icon.a21ec82e.svg";